import posthog from 'posthog-js'

import { POSTHOG_EVENTS } from '../constants/posthog'

const { REACT_APP_API_ENV } = process.env
const mappedEvents = new Set(Object.values(POSTHOG_EVENTS))

export const captureEvent = (eventName, properties = {}) => {
  if (!mappedEvents.has(eventName)) return null

  const globalEventProperties = {
    sistema: 'principiapay_app_aluno',
    origem_evento: 'client',
    ambiente: REACT_APP_API_ENV,
    bu: 'principiapay'
  }

  posthog.capture(eventName, { ...properties, ...globalEventProperties })
}
